import { render } from "./component_colorDropdown.vue?vue&type=template&id=af052594"
import script from "./component_colorDropdown.vue?vue&type=script&lang=js"
export * from "./component_colorDropdown.vue?vue&type=script&lang=js"

import "./component_colorDropdown.vue?vue&type=style&index=0&id=af052594&lang=css"

import exportComponent from "/Users/patrikhubner/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__